/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_GeburtstagInputs */

const en__field_geburtstag = /** @type {(inputs: _Field_GeburtstagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birthday`)
};

const de__field_geburtstag = /** @type {(inputs: _Field_GeburtstagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtstag`)
};

/**
* | output |
* | --- |
* | "Birthday" |
*
* @param {_Field_GeburtstagInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_geburtstag = /** @type {((inputs?: _Field_GeburtstagInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_GeburtstagInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_geburtstag(inputs)
	return de__field_geburtstag(inputs)
});